export const BASIC_INSTRUCTION_FRAGMENT = `
  fragment BasicInstructionFields on Instruction {
    id
    name
    text
  }
`
